import React, { useContext } from 'react'
import { arrayOf, objectOf, shape, string } from 'prop-types'
import { TextBox } from 'components/atoms'
import { FeatureList } from 'components/molecules'
import { TextContext } from 'hocs'

/**
 * simple feature list with additional textbox
 * @param mealInformation
 * @returns {JSX.Element}
 * @constructor
 */
const MealInformation = ({ mealInformation }) => {
  const { items = null, meals = {}, additionalInfo = null } = mealInformation
  const mealItems = Object.keys(meals)

  const textContext = useContext(TextContext)
  return (
    <>
      {items !== null && items.length > 0 && (
        <FeatureList
          itemList={ [{ title: '', items: mealInformation?.items }] }
          listClass='list-checkmark'
        />
      )}
      {!!meals && mealItems.length > 0 && (
        <TextBox
          key={ 'mealInfo' }
          title={ textContext['mealInformation.meals.title'] }>
          {mealItems.map((key, idx) => (
            <span key={ idx }>
              {`${ key }: ab ${ meals[key].start } Uhr bis ${ meals[key].end } Uhr`}
              {idx < mealItems.length - 1 ? <br /> : null}
            </span>
          ))}
        </TextBox>
      )}
      {additionalInfo !== null && additionalInfo !== '' && (
        <TextBox title={ '' }>{additionalInfo}</TextBox>
      )}
    </>
  )
}

MealInformation.propTypes = {
  mealInformation: shape({
    items: arrayOf(string),
    meals: objectOf(
      shape({
        start: string.isRequired,
        end: string.isRequired,
      })
    ),
    additionalInfo: string,
  }),
}

export default MealInformation
